import { render, staticRenderFns } from "./ArtistProfile.vue?vue&type=template&id=85a02836&scoped=true"
import script from "./ArtistProfile.vue?vue&type=script&lang=js"
export * from "./ArtistProfile.vue?vue&type=script&lang=js"
import style0 from "./ArtistProfile.vue?vue&type=style&index=0&id=85a02836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a02836",
  null
  
)

export default component.exports